
  import { Component, Prop, Mixins, Emit } from 'vue-property-decorator';
  import ImagesPreview from '../../../../core/components/Generics/Images/ImagesPreview.vue'
  import Vue from 'vue'
import { formatDate } from '../../../../core/utils/date-handlers';

  @Component({
    components: {
      ImagesPreview
    }
  })
  export default class ModalNoteInfoMap extends Vue {
    @Prop() visible: boolean;
    @Prop({ default: null }) noteInfo: any;
  
    selectedImageUrl: string = '';
  
    @Emit()
    closeModal() {}

    parseDate(date){
      return formatDate(date)
    }
  }
  